module.exports = Object.assign(
  {},
  require('./appStringsDa/part1'),
  require('./appStringsDa/part2'),
  require('./appStringsDa/part3'),
  require('./appStringsDa/part4'),
  require('./appStringsDa/part5'),
  require('./appStringsDa/part6'),
  require('./appStringsDa/commonStatus'),
  require('./appStringsDa/accountSettings')
);
